import { render, staticRenderFns } from "./TestItem.vue?vue&type=template&id=5b5a0190&scoped=true"
import script from "./TestItem.vue?vue&type=script&lang=js"
export * from "./TestItem.vue?vue&type=script&lang=js"
import style0 from "./TestItem.vue?vue&type=style&index=0&id=5b5a0190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a0190",
  null
  
)

export default component.exports